const { db } = require("../firebase");
const { collection, getDocs, getDoc, addDoc, updateDoc, deleteDoc, doc, where, query } = require("firebase/firestore");


const eng1CollectionRef = collection(db, "Baskin Engineering 1");
const eng2CollectionRef = collection(db, "Baskin Engineering 2");
const getCollectionRef = (buildingName) => {
    return collection(db, buildingName);
};

class PathDataService {
    addRooms = (newRoom) => {
        return addDoc(eng1CollectionRef, newRoom);
    };

    updateRooms = (id, updatedRoom) => {
        const RoomDoc = doc(db, "Baskin Engineering 1", id);
        return updateDoc(RoomDoc, updatedRoom);
    };

    deleteRoom = (id) => {
        const RoomDoc = doc(db, "Baskin Engineering 1", id);
        return deleteDoc(RoomDoc);
    };

    getAllRooms = (buildingName) => {
        const collectionRef = collection(db, buildingName);
        return getDocs(collectionRef);
    }

    getRoom = (id) => {
        const RoomDoc = doc(db, "Baskin Engineering 1", id);
        return getDoc(RoomDoc);
    }

    searchRoomByNumber = async (room, buildingName) => {
        const querySnapshot = await getDocs(query(eng1CollectionRef, where('room', '==', room)));
        return querySnapshot;
    }

    getNeighbor = async (value) => {
        // console.log("typeof 131: ", typeof "131");
        const querySnapshot = await getDocs(query(eng1CollectionRef, where('neighbors', 'array-contains', value)));
        return querySnapshot;
    }

    getNodesByFloor = async (floor, buildingName) => {
        // console.log("floor ", floor);
        // console.log("typeof floor: ", typeof floor);
        const querySnapshot = await getDocs(query(eng1CollectionRef, where('location', 'array-contains', floor)));
        return querySnapshot;
    }

    // getNodes = async () => {
    //     // console.log("floor ", floor);
    //     // console.log("typeof floor: ", typeof floor);
    //     const querySnapshot = await getDocs(query(getCollectionRef(buildingName)));
    //     return querySnapshot;
    // }

    // getStairsAndElevators = async () => {
    //     const querySnapshot = await getDocs(query(getCollectionRef(buildingName), where("information", "in", ["Stairs", "Elevator"])));
    //     return querySnapshot;
    // }
}

module.exports = new PathDataService();
